export const DASHBOARD_TAG_NAME = 'tm-bo-dashboard';
